import { IControl } from './Controls';

export interface IToggleButtonSetting {
    className?: string;
    toggleClass?: string;
    rootClass?: string;
    text: string;
}

const template = `<div class="toggleButton"><span class="caption"></span><span class="onoffswitch"></span></div>`;

export class ToggleButton implements IControl {
    private on: boolean;
    private root: JQuery;
    private switcher: JQuery;
    private onClickHandler: IHandler = $.noop;
    private onChangeHandler: IHandler = $.noop;

    constructor(private param: IToggleButtonSetting) {
        this.root = $(template);
        if (param.rootClass) {
            this.root.addClass(param.rootClass);
        }
        this.switcher = this.root.find('.onoffswitch');
        this.root.find('.caption').text(this.param.text);
        this.switcher.on('click', () => {
            this.enabled() && this.value(!this.on);
            this.onClickHandler();
        });
        this.on = false;
        this.applyStyles();

        const domChange = () => {
            if (this.root.elementInDOM()) {
                this.copyStyles();
                this.root.off('DOMNodeInserted', domChange);
            }
        };
        this.root.on('DOMNodeInserted', domChange);
    }

    private copyStyles(): void {
        this.root.css('fontSize', this.switcher.css('fontSize'));
        this.root.css('fontFamily', this.switcher.css('fontFamily'));
        this.root.css('color', this.switcher.css('color'));
    }

    private applyStyles() {
        this.toggleClass(this.param.toggleClass, this.param.className, this.on);
        this.toggleClass('on', 'off', this.on);
        this.copyStyles();
    }

    private toggleClass(on: string, off: string, setOn: boolean) {
        this.switcher.toggleClass(on, setOn);
        this.switcher.toggleClass(off, !setOn);
    }

    public value(on?: boolean): boolean {
        if (on !== undefined && this.on !== on) {
            this.on = on;
            this.applyStyles();
            this.onChangeHandler();
        }
        return this.on;
    }

    public adjust(width?: any, height?: any) {}

    public enabled(value?: boolean): boolean {
        if (value !== undefined) {
            this.root.toggleClass('disabled', !value);
        }
        return !this.root.hasClass('disabled');
    }

    public visible(value?: boolean): boolean {
        if (value !== undefined) {
            this.root.toggle(value);
        }
        return this.root.is(':visible');
    }

    public readonly(readonly?: boolean): boolean {
        if (readonly !== undefined) {
            this.enabled(!readonly);
        }
        return !this.enabled();
    }

    public destroy(): void {
        this.root.detach();
        this.root = null;
    }

    public getControl(): JQuery {
        return this.root;
    }

    public setState(enabled: boolean) {
        this.enabled(enabled);
    }

    public onClick(fn: IHandler) {
        this.onClickHandler = fn || $.noop;
    }

    public onChange(fn: IHandler) {
        this.onChangeHandler = fn || $.noop;
    }
}

namespace manualTests {
    export function toggleButton(root: JQuery) {
        const rr = new ToggleButton({ text: 'fsdfsdfsdf' });
        rr.getControl().appendTo(root);
        rr.value(true);

        rr.onClick(() => console.log('click'));
    }
}
